import { cn } from '@/lib/utils';
import { STATUSES } from '../constants';
import type { CustomerRequestStatus } from '../types';

export function CustomerRequestStatusBadge({ status, className, testId }: {
  status: CustomerRequestStatus;
  className?: string;
  testId?: string;
}) {
  const s = STATUSES.find((x) => x.value === status);
  return (
    <span
      data-testid={testId}
      className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium', s?.className, className)}
    >
      {s?.label ?? status}
    </span>
  );
}
